<div [formGroup]="formGroup">
    <mat-form-field *ngIf="isInputTypeText(formGroup) || isInputTypePhoneNumber(formGroup)" class="login-form-field login-enter-pii-answer-pii-field login-enter-pii-answer-form-field">
        <mat-label>{{formGroup.get('piiField').value.label}}</mat-label>
        <input matInput formControlName="answer" />
    </mat-form-field>
    <div *ngIf="isInputTypeMaskedText(formGroup)" class="login-enter-pii-answer-pii-field">
        <app-obscured-input formControlName="answer" [label]="formGroup.get('piiField').value.label" width="100%">
        </app-obscured-input>
    </div>
    <mat-form-field *ngIf="isInputTypeDateTime(formGroup)" class="login-form-field login-enter-pii-answer-pii-field login-enter-pii-answer-form-field">
        <mat-label>{{formGroup.get('piiField').value.label}}</mat-label>
        <input matInput [matDatepicker]="dobPicker" formControlName="answer">
        <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker></mat-datepicker>
    </mat-form-field>
    <app-alert-error *ngIf="isInputTypePhoneNumber(formGroup) && formGroup.get('answer')?.hasError('phoneNumber')">Phone Number is not valid</app-alert-error>
</div>